import { Children, FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { Container as ContainerUI } from "@jti/ui/eva-components/Container";

import { Placeholder } from "../Placeholder/Placeholder";

export const Container: FC<PropsWithChildren> = ({ children }) => {
  if (isEditing() && Children.count(children) === 0) {
    return <Placeholder>Drag and drop component here</Placeholder>;
  }
  return <ContainerUI>{children}</ContainerUI>;
};
